var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.invoiceUrl
      ? _c("div", { staticClass: "error-message" }, [
          _c(
            "div",
            { staticClass: "icon-wrapper" },
            [
              _c("information-outline-icon", {
                staticClass: "info-icon",
                attrs: { size: 20, fillColor: "#eb4a4a" },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "message-content" }, [
            _c("div", [
              _vm._v(_vm._s(_vm.$t("paymentDescription.paymentFailed"))),
            ]),
            _c("div", [
              _vm._v(" " + _vm._s(_vm.$t("paymentDescription.proceedPrefix"))),
              _c("a", { attrs: { href: _vm.invoiceUrl, target: "_blank" } }, [
                _vm._v(_vm._s(_vm.$t("common.here"))),
              ]),
              _vm._v(_vm._s(_vm.$t("paymentDescription.proceedSuffix")) + " "),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }